export const scrollableContentStyles = {
  wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxHeight: 'min(600px, calc(100vh - 200px))',
  },

  header: {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    backgroundColor: ({ palette }) => palette.background.default,
    borderColor: ({ palette }) => palette.border.default,
  },

  content: {
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    position: 'relative',
    marginBottom: '12px',
  },

  footer: {
    position: 'sticky',
    bottom: 0,
    zIndex: 2,
    backgroundColor: ({ palette }) => palette.background.secondary,
    borderRadius: 1,
  },
};
